"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const jsHelpers_2 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const js_synchronisation_1 = require("../js-synchronisation");
const serialization_1 = require("../serialization");
const js_transaction_1 = require("../js-transaction");
const js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
const js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
const js_signOperation_1 = __importDefault(require("../js-signOperation"));
const js_broadcast_1 = __importDefault(require("../js-broadcast"));
const receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
const currencyBridge = {
    preload: () => __awaiter(void 0, void 0, void 0, function* () { return Promise.resolve({}); }),
    hydrate: () => { },
    scanAccounts: js_synchronisation_1.scanAccounts,
};
const accountBridge = {
    estimateMaxSpendable: js_estimateMaxSpendable_1.default,
    createTransaction: js_transaction_1.createTransaction,
    updateTransaction: jsHelpers_2.defaultUpdateTransaction,
    getTransactionStatus: js_getTransactionStatus_1.default,
    prepareTransaction: js_transaction_1.prepareTransaction,
    sync: js_synchronisation_1.sync,
    receive,
    signOperation: js_signOperation_1.default,
    broadcast: js_broadcast_1.default,
    assignFromAccountRaw: serialization_1.assignFromAccountRaw,
    assignToAccountRaw: serialization_1.assignToAccountRaw,
};
exports.default = {
    currencyBridge,
    accountBridge,
};
//# sourceMappingURL=js.js.map